import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types"; // Импортируем PropTypes

export const EditOrderModal = ({
  showModal,
  closeEditModal,
  editingOrder,
  handleEditChange,
  saveOrder,
}) => {
  return (
    <Modal show={showModal} onHide={closeEditModal}>
      <Modal.Header closeButton>
        <Modal.Title>Редактирование заказа</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formPartnerId">
            <Form.Label>ID клиента</Form.Label>
            <Form.Control
              type="text"
              name="partner_id"
              value={editingOrder?.partner_id || ""}
              onChange={handleEditChange}
            />
          </Form.Group>
          <Form.Group controlId="formOrderAmount">
            <Form.Label>Сумма заказа</Form.Label>
            <Form.Control
              type="text"
              name="order_amount"
              value={editingOrder?.order_amount || ""}
              onChange={handleEditChange}
            />
          </Form.Group>
          <Form.Group controlId="formOrderDate">
            <Form.Label>Дата создания сделки </Form.Label>
            <Form.Control
              type="datetime-local"
              name="order_date"
              value={
                editingOrder?.order_date &&
                !isNaN(new Date(editingOrder.order_date))
                  ? new Date(editingOrder.order_date).toISOString().slice(0, 16)
                  : ""
              }
              onChange={handleEditChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeEditModal}>
          Отмена
        </Button>
        <Button variant="primary" onClick={saveOrder}>
          Сохранить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EditOrderModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeEditModal: PropTypes.func.isRequired,
  editingOrder: PropTypes.shape({
    partner_id: PropTypes.string,
    order_amount: PropTypes.number,
    order_date: PropTypes.string,
  }),
  handleEditChange: PropTypes.func.isRequired,
  saveOrder: PropTypes.func.isRequired,
};

export const EditPartnerModal = ({
  showEditPartnerModal,
  closeEditPartnerModal,
  partnerData,
  handlePartnerChange,
  savePartner,
}) => {
  return (
    <Modal show={showEditPartnerModal} onHide={closeEditPartnerModal}>
      <Modal.Header closeButton>
        <Modal.Title>Редактирование данных партнера</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formPartnerName">
            <Form.Label>ФИО партнера</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={partnerData.name}
              onChange={handlePartnerChange}
            />
          </Form.Group>
          <Form.Group controlId="formPartnerEmail">
            <Form.Label>Email партнера</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={partnerData.email}
              onChange={handlePartnerChange}
            />
          </Form.Group>
          <Form.Group controlId="formPartnerPhone">
            <Form.Label>Телефон партнера</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={partnerData.phone}
              onChange={handlePartnerChange}
            />
          </Form.Group>
          <Form.Group controlId="formPartnerAddress">
            <Form.Label>Адрес партнера</Form.Label>
            <Form.Control
              type="text"
              name="address"
              value={partnerData.address}
              onChange={handlePartnerChange}
            />
          </Form.Group>
          <Form.Group controlId="formPartnerNote">
            <Form.Label>Примечание</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="note"
              value={partnerData.note}
              onChange={handlePartnerChange}
            />
          </Form.Group>
          <Form.Group controlId="formPartnerBirthday">
            <Form.Label>День рождения</Form.Label>
            <Form.Control
              type="date"
              name="birthday"
              value={
                partnerData.birthday
                  ? new Date(partnerData.birthday).toISOString().slice(0, 10)
                  : ""
              }
              onChange={handlePartnerChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeEditPartnerModal}>
          Отмена
        </Button>
        <Button variant="primary" onClick={savePartner}>
          Сохранить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EditPartnerModal.propTypes = {
  showEditPartnerModal: PropTypes.bool.isRequired,
  closeEditPartnerModal: PropTypes.func.isRequired,
  partnerData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    note: PropTypes.string,
    birthday: PropTypes.string,
  }).isRequired,
  handlePartnerChange: PropTypes.func.isRequired,
  savePartner: PropTypes.func.isRequired,
};

export const PaymentModal = ({
  show,
  onHide,
  selectedOrdersTotal,
  selectedOrders,
  confirmPayment,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Подтверждение оплаты</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Сумма к выплате:</strong> {selectedOrdersTotal.toFixed(2)} €
        </p>
        <p>
          Вы уверены, что хотите оплатить {selectedOrders.length} заказ(ов)?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Отмена
        </Button>
        <Button variant="success" onClick={confirmPayment}>
          Подтвердить оплату
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

PaymentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  selectedOrdersTotal: PropTypes.number.isRequired,
  selectedOrders: PropTypes.array.isRequired,
  confirmPayment: PropTypes.func.isRequired,
};
